module.exports = [{
      plugin: require('/etc/jenkins-agent/workspace/bsites_inPower_Build_master-UHXFXXE354YQSA2MFWDY476FKNKUG4GBCUBVMM6THQDG4SIW4I7Q/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
